module.exports = __webpack_public_path__ + "static/media/definicija.5f97e325.jpg";